export function safeStringify(obj: unknown, space?: string | number): string {
    // Paths are tracked here instead of on the values themselves, so input objects are never mutated
    // (frozen objects stay supported and repeated calls on the same object do not collide).
    const seen = new WeakMap<object, string>();

    function serializer(this: object, key: string, value: unknown): unknown {
        // The root call gets an anonymous wrapper object as `this`, which is not in the map.
        const path = seen.get(this) ?? '$';
        const currentPath = Array.isArray(this) ? `${path}[${key}]` : key ? `${path}.${key}` : path;

        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return `[duplicate of ${seen.get(value)}]`;
            }
            seen.set(value, currentPath);
        }

        return value;
    }

    return JSON.stringify(obj, serializer, space);
}
